import { NgModule, ErrorHandler  } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { SidebarComponent } from '@standalone/components/sidebar/sidebar.component';
import { HttpClientModule } from '@angular/common/http';
import { TranslocoRootModule } from './transloco-root.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MarkdownModule } from 'ngx-markdown';
import { FeedbackButtonComponent } from '@standalone/components/feedback-button/feedback-button.component';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';
import * as Sentry from '@sentry/angular';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    AppRoutingModule,
    SidebarComponent,
    HttpClientModule,
    TranslocoRootModule,
    ServiceWorkerModule.register('web-push-service-worker.js', {
      enabled: true,
      registrationStrategy: 'registerImmediately',
    }),
    MatSidenavModule,
    MarkdownModule.forRoot(),
    FeedbackButtonComponent,
  ],
  providers: [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        hasBackdrop: true,
        width: '500px',
        maxWidth: 'calc(100vw - 2rem)',
      },
    },
    {
      provide: ErrorHandler,
      useValue: environment.sentryEnabled ? Sentry.createErrorHandler() : new ErrorHandler(),
    },
    provideTranslocoLocale({
      langToLocaleMapping: {
        en: 'en-US',
        ru: 'ru-RU',
      },
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
